import { render, staticRenderFns } from "./index.vue?vue&type=template&id=95471a6a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=95471a6a&prod&scoped=true&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=95471a6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95471a6a",
  null
  
)

export default component.exports